<template>
  <section id="device_container" class="device-container">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <ModalAddDevice
      ref="refCreateDevice"
      v-bind:device="actualDevice"
      v-if="actualDevice"
      @pushSubItemDevice="pushSubItemDevice"
      @closeModal="closeModal"
    />
    <div class="add-item-header grid-columns">
      <div class="column">
        <CompanySelector v-model="company" />
      </div>
      <div class="column">
        <b-field label="Tipo de dispositivo *">
          <b-select
              placeholder="Tipo de disposiitvo"
              expanded
              name="deviceType"
              v-model="deviceType"
          >
            <option
              v-for="option in deviceTypes"
              :value="option.code"
              :key="option.code"
              :id="option.code"
            >
              {{ option.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nombre de dispositivo  *">
          <b-input
              placeholder="Nombre de dispositivo"
              type="text"
              name="deviceName"
              v-model="deviceName"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Estado *">
          <b-select
              placeholder="Estado"
              expanded
              v-model="status"
              name="status"
          >
            <option
              v-for="option in statusList"
              :value="option.code"
              :key="option.code"
              :id="option.code"
            >
              {{ $t(option.description) }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nickname *">
          <b-input
              placeholder="Nickname"
              type="text"
              name="nickname"
              v-model="nickname"
          />
        </b-field>
      </div>
      <div
        v-for="(field, index) in dinamycFields"
        :key="field.key"
        :id="field.key"
        :class="field.hide ? 'hide' : 'item-field'"
        :style="getColumnStyle(field)"
      >
        <div class="column" v-if="!field.hide">
          <DinamycField
            v-bind:field="field"
            v-bind:index="index"
            v-bind:dynamicFields="dinamycFields"
            v-bind:dinamycValueFields="dinamycValueFields"
            v-bind:slot-list="slotList"
            @onChange="onChangeValue"
          />
        </div>
      </div>
      <div class="column mt-button">
        <vs-button
          color="primary"
          class="pl-5 pr-5"
          icon="add"
          type="filled"
          @click="addDevice"
          :disabled="isAddable"
        >
          Agregar
        </vs-button>
      </div>
    </div>

    <!-- CONTENIDO INFERIOR ITEM LISTA DISPOSITIVOS AGREGADOS -->
    <div class="devices-items-content">
      <div
        class="device-item-content column mt-4"
        v-for="(device, index) in devices"
        :key="index"
        :id="index"
      >
        <DeviceForm
          :key="index"
          v-bind:device="device"
          v-bind:deviceTypes="deviceTypes"
          v-bind:slot-list="slotList"
          @addDeviceSubitem="addDeviceSubitem"
          @deleteDevice="deleteDevice"
          @editDevice="editDevice"
          @onChangeCompany="onChangeCompany"
        />
      </div>
    </div>
    <div
      class="form-footer mt-3 text-right"
      v-if="Array.isArray(devices) && devices.length > 0"
    >
      <vs-button
        color="success"
        class="pl-5 pr-5"
        icon="save"
        type="filled"
        @click="saveChanges"
      >
        Guardar Cambios
      </vs-button>
      <vs-button
        color="danger"
        class="pl-5 pr-5 ml-3"
        icon="close"
        type="filled"
        @click="saveChanges"
      >
        Descartar Cambios
      </vs-button>
    </div>
  </section>
</template>

<script>
import CompanySelector from '../../../components/Shared/CompanySelector'
import ModalAddDevice from './ModalAddDevice.vue'
import Loader from '../../../components/Shared/Loader.vue'
import { ROUTES } from '@/global/api_routes'
import { DETAILS_STATUS } from '@/global/constants'
import { validator } from '@/global/validator'
import { getParameterByName } from '@/global/utils'
import DeviceForm from './DeviceForm.vue'
import DinamycField from './DinamycField.vue'
import { configToast, TOAST_TYPES } from '@/global/toast'
import { get as getProp } from 'object-path'
import SlotEndpoint from '@/endpoints/core/SlotEndpoint'

export default {
  components: {
    CompanySelector,
    Loader,
    DeviceForm,
    ModalAddDevice,
    DinamycField,
  },
  data: () => ({
    actualDevice: null,
    isLoading: false,
    company: null,
    deviceType: null,
    deviceName: null,
    status: null,
    dinamycFields: [],
    dinamycValueFields: [],
    statusList: [],
    deviceTypes: [],
    devices: [],
    nickname: null,
    isAddable: false,
    slotList: [],
  }),
  mounted() {
    this.validateDeviceCompany()
    this.getDeviceTypes()
    this.getDeviceDetails()
    this.statusList = this.getStatusList()
  },
  watch: {
    deviceType: function (id) {
      this.validate()
      if (!id) {
        return
      }
      this.getDeviceTypesFields(id)
    },
    deviceName() {
      this.validate()
    },
    deviceTypes: function () {
      this.validate()
    },
    dinamycValueFields: function () {
      this.validate()
    },
    dinamycFields() {
      this.validate()
    },
    status() {
      this.validate()
    },
    company() {
      this.validateDeviceCompany()
    },
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, '#device_container')
      return instance.open(message, type)
    },
    getColumnStyle(field) {
      return field.fullWidth ? { 'grid-column': '1 / -1' } : {}
    },
    onChangeCompany(changes) {
      console.log('CHANGES', changes)
      this.devices = this.devices.map((item) => {
        if (item.code === changes.device.code) {
          item.company = changes.company.code
        }
        return item
      })
    },
    saveDevice(device) {
      return this.$http.post(
        ROUTES.DASHBOARD.CONFIG_DEVICES.SAVE_DEVICE,
        this.getDeviceObject(device, device.father)
      )
    },
    onChangeValue(change) {
      const obj = { ...this.dinamycValueFields }
      obj[change.key] = change.value
      this.dinamycValueFields = obj
      this.validate()
    },
    getDeviceObject(device, father) {
      const obj = {
        code: device.code,
        company: {
          code: device.company.code ? device.company.code : device.company,
        },
        title: device.deviceName,
        deviceType: {
          code: device.deviceType.code
            ? device.deviceType.code
            : device.deviceType,
        },
        status: device.status,
        info: JSON.stringify(device.dinamycValueFields),
        father: father,
        nickname: device.nickname,
      }
      return obj
    },
    generateToken(device) {
      //#FIX: Revisar porque aquí al cambiar por get se pudo afectar ya que se está enviando un objeto...
      return this.$http.get(ROUTES.DASHBOARD.DEVICES.GENERATE_TOKEN, {
        params: { device },
      })
    },
    checkResult(response) {
      if (response.data.code < 0) {
        throw new Error(response.data.message)
      }
    },
    async saveDeviceControl(device) {
      const response = await this.saveDevice(device)
      this.checkResult(response)
      try {
        const info = JSON.parse(getProp(response, 'data.info.info', '{}'))
        device.code = JSON.parse(getProp(response, 'data.info.code', '{}'))
        device.token = info.token
      } catch (error) {}
      if (device && device.token) {
        device.dinamycValueFields.token = device.token
      }
    },
    async saveChanges() {
      this.isLoading = true
      try {
        console.log('DEVICES', this.devices)
        for (let i = 0; i < this.devices.length; i++) {
          const device = this.devices[i]
          await this.saveDeviceControl(device)
          if (
            Array.isArray(device.devices) &&
            device.devices.length > 0 &&
            device.code > 0
          ) {
            for (let j = 0; j < device.devices.length; j++) {
              const subdevice = device.devices[j]
              subdevice.father = device.code
              await this.saveDeviceControl(subdevice)
            }
          }
        }
        this.devices = this.devices.map((item) => ({
          ...item,
          time: new Date(),
        }))
        this.toast(
          'Se han guardado los dispositivos correctamente.',
          TOAST_TYPES.SUCCESS
        )
      } catch (error) {
        const message = error.message || 'Lo sentimos se ha producido un error.'
        this.toast(message, TOAST_TYPES.ERROR)
      }
      this.isLoading = false
    },
    sendDelete(device) {
      this.isLoading = true
      return this.$http.delete(ROUTES.DASHBOARD.CONFIG_DEVICES.DELETE, {
        deviceId: device.code,
      })
    },
    editDevice(device) {
      let index = this.devices.findIndex(
        (d) => d.deviceName === device.deviceName
      )
      if (index >= 0) {
        this.actualDevice = { ...device, editing: { parent: index } }
        return
      }
      //Buscamos si el device que se está editando pertenece a un subdevice...
      this.devices.forEach((d, i) => {
        const subdevice = d.devices.findIndex(
          (dv) => dv.deviceName === device.deviceName
        )
        if (subdevice >= 0) {
          this.actualDevice = {
            ...d.devices[subdevice],
            editing: { parent: i, subitem: subdevice },
          }
        }
      })
    },
    async deleteDevice(device) {
      const devicesTemp = this.devices.map((item) => {
        const temp = { ...item }
        if (Array.isArray(item.devices)) {
          const index = item.devices.findIndex(
            (subdevice) => subdevice.deviceName === item.deviceName
          )
          temp.devices.splice(index, 1)
        }
        return temp
      })
      const index = devicesTemp.findIndex(
        (item) => item.deviceName === device.deviceName
      )
      if (index >= 0) {
        devicesTemp.splice(index, 1)
      }
      if (device.code) {
        await this.sendDelete(device)
        this.isLoading = false
      }
      this.devices = devicesTemp
    },
    findByName(device) {
      let finded = null
      for (let i = 0; i < this.devices.length; i++) {
        const deviceItem = this.devices[i]
        if (deviceItem.deviceName === device.deviceName) {
          return deviceItem
        }
        if (Array.isArray(device.devices) && !finded) {
          finded = device.devices.find(
            (d) => d.deviceName === device.deviceName
          )
        }
      }
      return finded
    },
    updateSubItemDevice(device) {
      const { parent, subitem } = device.editing
      const devicesTempList = this.devices.map((d) => {
        return { ...d }
      })
      if (subitem >= 0) {
        delete device.editing
        devicesTempList[parent].devices[subitem] = { ...device, updated: true }
      }
      this.devices = devicesTempList
      this.closeModal()
    },
    pushSubItemDevice(obj) {
      const { device, subdevice } = obj
      if (device.editing) {
        return this.updateSubItemDevice({ ...device, ...subdevice })
      }
      const exist = this.findByName(subdevice)
      if (exist) {
        this.showDuplicateDeviceNameMessage()
        return
      }
      const tempDevices = this.devices.map((d) => {
        return { ...d }
      })
      const index = this.devices.findIndex(
        (d) => d.deviceName === device.deviceName
      )
      if (index < 0) {
        return
      }
      if (!Array.isArray(tempDevices[index].devices)) {
        tempDevices[index].devices = []
      }
      subdevice.company = device.company

      tempDevices[index].devices.push(subdevice)
      this.devices = tempDevices
      this.closeModal()
    },
    addDeviceSubitem(device) {
      this.actualDevice = { ...device }
    },
    validate() {
      const rules = [
        { field: 'deviceType' },
        { field: 'company' },
        { field: 'deviceName' },
        { field: 'status' },
      ]
      const extraValues = {}
      this.dinamycFields.forEach((field, index) => {
        if (field.required) {
          rules.push({ field: field.key })
          extraValues[field.key] = this.dinamycValueFields[field.key]
        }
      })
      const { result, errors } = validator({ ...this, ...extraValues }, rules)
      this.isAddable = !result
    },
    showDuplicateDeviceNameMessage() {
      this.toast(
        'Ya existe un dispositivo con el mismo nombre',
        TOAST_TYPES.ERROR
      )
    },
    checkForEntryAndOutDevice(exist, obj) {
      const deviceType = obj.deviceTypes.find(
        (item) => item.code === obj.deviceType
      )
      //Primero validamos que el dispositivo sea de tipo Entrada o salida...
      if (
        getProp(deviceType, 'initials') !== 'DE' &&
        getProp(deviceType, 'initials') !== 'DX'
      ) {
        return true
      }
      //Si es de tipo entrada o salida se hará la validación...
      return exist.deviceType === obj.deviceType
    },
    addDevice() {
      const obj = {
        company: this.company,
        deviceName: this.deviceName,
        deviceType: this.deviceType,
        status: this.status,
        ...this.dinamycValueFields,
        deviceTypes: this.deviceTypes,
        statusList: this.statusList,
        dinamycFields: this.dinamycFields,
        dinamycValueFields: { ...this.dinamycValueFields },
        nickname: this.nickname,
      }
      console.log(obj)
      const exist = this.findByName(obj)
      if (exist && this.checkForEntryAndOutDevice(exist, obj)) {
        this.showDuplicateDeviceNameMessage()
        return
      }
      this.devices.push(obj)
      this.cleanForm()
    },
    cleanForm() {
      this.deviceName = null
      this.deviceType = null
      this.status = null
      this.dinamycFields = []
      this.dinamycValueFields = {}
      this.nickname = null
    },
    getStatusList() {
      const list = []
      for (const key in DETAILS_STATUS) {
        if (Object.hasOwnProperty.call(DETAILS_STATUS, key)) {
          const itemStatus = DETAILS_STATUS[key]
          list.push(itemStatus)
        }
      }
      return list
    },
    getDeviceTypesFields(id) {
      this.isLoading = true
      this.dinamycFields = []
      this.dinamycValueFields = {}
      this.$http
        .get(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICE_TYPE_FIELDS, {
          params: {
            deviceTypeId: id,
          },
        })
        .then(({ data }) => {
          if (data.code < 1 || !data.info) {
            this.dinamycFields = []
            this.dinamycValueFields = {}
            return
          }
          this.dinamycFields = JSON.parse(data.info.fields)
          this.dinamycFields.forEach((field) => {
            this.dinamycValueFields[field.key] = null
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getDeviceTypes() {
      this.$http
        .get(ROUTES.DASHBOARD.ENTITY.GET_LIST_BY_KIND, {
          params: {
            kindId: 11,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.deviceTypes = data.info
          }
        })
    },
    closeModal() {
      this.actualDevice = null
    },
    applyExtraValues(obj) {
      if (!Array.isArray(obj.dinamycFields)) {
        obj.dinamycFields = []
      }
      if (typeof obj.dinamycValueFields !== 'object') {
        obj.dinamycValueFields = {}
      }
      return obj
    },
    getToken(device) {},
    getDeviceDetails() {
      const deviceCode = getParameterByName('code')
      if (!deviceCode) {
        return
      }
      this.isLoading = true
      this.$http
        .get(
          `${ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICE}?deviceCode=${deviceCode}`
        )
        .then(({ data }) => {
          const device = data.info
          device.token = JSON.parse(getProp(data, 'info.info', '{}')).token
          console.log('token', device.token)
          const devices = [
            this.applyExtraValues({
              code: device.code,
              deviceName: device.title,
              company: device.company.code,
              deviceType: device.deviceType.code,
              status: device.status,
              deviceTypes: this.deviceTypes,
              statusList: this.statusList,
              token: device.token,
              dinamycFields: device.deviceProperty
                ? JSON.parse(device.deviceProperty.fields)
                : {},
              dinamycValueFields: device.info ? JSON.parse(device.info) : {},
              devices: device.devicesList.map((item) => {
                return this.applyExtraValues({
                  code: item.code,
                  deviceName: item.title,
                  company: item.company.code,
                  deviceType: item.deviceType.code,
                  status: item.status,
                  deviceTypes: this.deviceTypes,
                  statusList: this.statusList,
                  dinamycFields: item.deviceProperty
                    ? JSON.parse(item.deviceProperty.fields)
                    : [],
                  dinamycValueFields: item.info ? JSON.parse(item.info) : [],
                  father: item.code,
                  nickname: item.nickname,
                })
              }),
              nickname: device.nickname,
            }),
          ]
          this.devices = devices
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    /**
     * lista los lotes asignados a la compañía
     */
    listSlotsByCompany() {
      this.slotList = []
      SlotEndpoint.listByCompany(this.company).then((data) => {
        if (data.length <= 0) {
          return
        }
        data.forEach((slot) => {
          const findSlot = {
            name: slot.id + ' - ' + slot.title,
            code: slot.code,
          }
          this.slotList.push(findSlot)
        })
      })
    },
    /**
     * valida si la compañia es valida para buscar los lotes
     */
    validateDeviceCompany() {
      if (!this.company) {
        return
      }
      this.listSlotsByCompany()
    },
  },
}
</script>

<style>
.device-item-content {
  background-color: #ffffff;
  box-shadow: 0px 1px 3px #5e5e5e;
  border-radius: 5px;
}

.device-item-content .header-content {
  padding: 10px 30px;
}

.device-item-content .header-content .legend {
  font-weight: bold;
  font-size: 1.2em;
}

.device-item-content .body-content {
  padding: 30px;
  padding-top: 0px;
}

.devices-items-content {
  display: block;
  padding: 0 15px;
}

.add-item-header {
  background-color: #f0f5f9;
  border-bottom: 1px solid #d8d8d8;
}

.modal-widget {
  background-color: #ffffff;
  border-radius: 5px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 15px;
}

.modal-widget .btn-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 0;
  box-shadow: none;
  font-size: 1.2em;
  background-color: #f64651;
  color: #ffffff;
}

.modal-widget .btn-close:hover {
  background-color: black;
  color: #ffffff;
}

.modal-widget .modal-title {
  display: block;
  height: 25px;
  text-align: left;
  padding: 10px 15px;
  padding-bottom: 30px;
}

.modal-widget .modal-title .title {
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 1.5em;
  font-weight: bold;
}

.modal-widget .modal-body {
  display: block;
}

.form-footer {
  display: flex;
  padding: 5px 15px;
  justify-content: flex-end;
}
</style>
